import FupPersonListPagingResultModelBase from '../_generated/modelBases/fup-person-list-paging-result-model-base';

export default class FupPersonListPagingResultModel extends FupPersonListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
